var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"title-header"},[_c('span',{staticClass:"first-word"},[_vm._v(_vm._s(_vm.first))]),_c('span',{staticClass:"rest-words"},[_vm._v(_vm._s(_vm.rest))])])
}
var staticRenderFns = []

export { render, staticRenderFns }